import AppPagination from './AppPagination.vue'

export { AppPagination }
